import Vue from 'vue';
import capitalMarketPublications from './capital-market-publications/capital-market-publications.vue';
Vue.component('capital-market-publications', capitalMarketPublications);
